
export default function urlParams(winLocationSearch: string): HashMap<string> {
  // let urlObj = <any>ioQuery.queryToObject(winLocationSearch.replace(/^\?/, ""));
  let urlObj;
  urlObj = urlObj || {};

  for (const key in urlObj) {
    if (urlObj.hasOwnProperty(key) && typeof urlObj[key] === "string") {
      // strip out some HTML (<,>,%3C,%3E,&lt;,&gt;)
      urlObj[key] = urlObj[key].replace(/(&lt;|&gt;|<|>|%3C|%3E)/g, "");
    }
  }
  return urlObj;
}

export function findEnvironmentByUrl(): "dev" | "qa" | "prod" | null {
  const hostname = window.location.hostname;
  if (hostname.includes("devext.arcgis")) {
    return "dev";
  } else if (hostname.includes("qa.arcgis")) {
    return "qa";
  } else if (!hostname.includes("arcgis")) {
    return "dev" // presumably "localhost", but uses "dev" resources, so return "dev"
  } else if (hostname.includes("arcgis")) {
    return "prod";
  } else {
    return null;
  }
}

/**
 * Adds new URL Param to the current url. 
 * Returns full href for new URL.
 */
export function addUrlParam(
  key: string, 
  value: string,
  manualUrl?: string
): string {
  const tempUrl = new URL(manualUrl ?? window.location.href);
  if(tempUrl.searchParams.has(key)){
    tempUrl.searchParams.delete(key);
  }
  tempUrl.searchParams.append(key, value);
  return tempUrl.href;
}

export function removeUrlParam(
  key: string | string[],
  manualUrl?: string
): string {
  const tempUrl = new URL(manualUrl ?? window.location.href);
  if(Array.isArray(key)){
    key.forEach((keyStr => { tempUrl.searchParams.delete(keyStr); }));
  }else{
    tempUrl.searchParams.delete(key);
  }
  return tempUrl.href;
}
